module.exports = __webpack_public_path__ + "img/1873 (Large).9d022e24.jpg";